import { TherapeuticPlansAPI } from "../../therapeutic_plan";

type ListParams = Parameters<typeof TherapeuticPlansAPI.list_by_patient>[1];

export async function listPatientTherapeuticPlans(patientId: string, params?: ListParams) {
  const { data } = await TherapeuticPlansAPI.list_by_patient(patientId, params);
  return data;
}

export async function listCoupleTherapeuticPlans(couplePatientId: string, params?: ListParams) {
  const { data } = await TherapeuticPlansAPI.list_by_couple_patient(couplePatientId, params);
  return data;
}

export async function deleteTherapeuticPlan(id: string) {
  await TherapeuticPlansAPI.delete(id);
}
